import React, { useContext, useState, useEffect } from 'react'

import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { useTranslation } from 'react-i18next'
import './invoice.css'
import {
    dateFormatFront,
    currencyFormat,
    capitalize,
    dateTimeFormatFunction,
} from '@/custom/common/components'
import { Button } from '@material-ui/core'
import UserContext from '@/product/context/seller/user/userContext'
import { LOGO, SITE_NAME } from '@/utils'
import AlertContext from '@/product/context/alert/alertContext'

const InvoiceView = (props) => {
    const customCommonContext = useContext(CustomCommonContext)
    const alertContext = useContext(AlertContext)
    const userContext = useContext(UserContext)
    const { setAlert } = alertContext
    const { t } = useTranslation()
    const [viewContent, setViewContent] = React.useState(null)
    const [print, setPrint] = useState(false)
    const [invoiceDetails, setInvoiceDetails] = useState(null)

    const data = props.data
    const toggleFullScreenPopup = props.function
    const [invoiceList, setInvoiceList] = useState(props.array ?? [])

    useEffect(() => {
        if (props.array && props.array.length) setInvoiceList(props.array)
    }, [props.array])

    useEffect(() => {
        if (invoiceList.length) {
            let val = invoiceList.find((e) => e.id == data.id)
            setInvoiceDetails(val)
        }
    }, [data.id, invoiceList])

    const cap = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }

    const resetFrom = () => {
        setViewContent(null)
    }

    const ref = React.createRef()

    const closeFunction = () => {
        toggleFullScreenPopup(false)
        props.closeFunction()
    }
    console.log(invoiceDetails, props, 'test')
    return (
        <FullScreenPopup
            modaltitle={<span className="noPrint">View Invoice</span>}
            open={data.popup}
            className={'invoiceFullScreen'}
            handleClose={() => closeFunction()}
        >
            <div className="container-lg productInvoice">
                <h3 className="invoiceTitle">{'Subscription invoice'}</h3>
                <div className="d-flex justify-content-between align-items-center mb-2 noPrint">
                    <Button id="invoice_print_new" onClick={() => window.print()}>
                        <span className="material-icons">print</span>
                        {'Print'}
                    </Button>
                </div>
                <div className={`invoiceView`} style={{ height: '100%', width: '100%' }}>
                    <div className="card-header row ">
                        <div className="col-md-12 text-left">
                            <a className="pt-2 d-inline-block" data-abc="true">
                                <img
                                    src={LOGO}
                                    className="invLogo"
                                    alt={SITE_NAME}
                                    style={{ width: '240px' }}
                                />
                            </a>
                            <div>
                                <p className="text-dark  mt-2 mb-0">{SITE_NAME}</p>
                            </div>
                        </div>
                    </div>
                    <h2 className="text-center taxInvoiceHeader">SUBSCRIPTION INVOICE</h2>

                    <div className="card-body">
                        <div className="row mb-4">
                            <div className={`col-md-6 invAddr`}>
                                <p className="textBold">Customer Details</p>
                                <p className="cstmrNameTxt">{invoiceDetails?.users_full_name} </p>

                                <>
                                    {
                                        <p>
                                            {invoiceDetails?.users_city}, <br />
                                            {invoiceDetails?.users_country} -{' '}
                                            {invoiceDetails?.users_zip}
                                        </p>
                                    }
                                </>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-5">
                                        <p className="m-0 textBold mobCls">Invoice Number</p>
                                    </div>
                                    <div className="col-md-1 textBold colon">:</div>
                                    <div className="col-md-6">
                                        <p className="m-0">{invoiceDetails?.id}</p>
                                    </div>
                                    <div className="col-md-5">
                                        <p className="m-0 textBold mobCls">Invoice Date</p>
                                    </div>
                                    <div className="col-md-1 textBold colon">:</div>
                                    <div className="col-md-6">
                                        <p className="m-0">
                                            {dateFormatFront(invoiceDetails?.date_added)}
                                        </p>
                                    </div>
                                    <div className="col-md-5">
                                        <p className="m-0 textBold mobCls">Invoice Status:</p>
                                    </div>
                                    <div className="col-md-1 textBold colon">:</div>
                                    <div className="col-md-6">
                                        <p className="m-0">{'paid'}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-5">
                                        <p className="textBold d-flex justify-content-between mobSpecCls">
                                            Phone
                                        </p>
                                    </div>
                                    <div className="col-md-1 textBold colon">:</div>
                                    <div className="col-md-6">
                                        <p>{invoiceDetails?.users_phone}</p>
                                    </div>
                                </div>
                            </div>

                            <>
                                <div className="col-md-2">
                                    <p className="textBold d-flex justify-content-between mobSpecCls">
                                        Email
                                        <span className="colon">:</span>
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <p>{invoiceDetails?.users_email}</p>
                                </div>
                                <div className="col-md-6"></div>
                            </>
                        </div>
                        {invoiceDetails ? (
                            <>
                                <h4 className="invoiceSubTitle">{'Transaction details'}</h4>
                                <div className="transDet d-flex justify-content-between flex-wrap">
                                    <>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    {/* <th scope="col">S.No</th> */}
                                                    <th scope="col">{'Transaction id'}</th>
                                                    <th scope="col">{'Paid on'}</th>
                                                    <th scope="col">{'Method'}</th>
                                                    <th scope="col">{'Amount'}</th>
                                                    <th scope="col">{'Status'}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        {invoiceDetails?.trans_id
                                                            ? `# ${invoiceDetails?.trans_id}`
                                                            : '-'}
                                                    </td>
                                                    <td>
                                                        {dateTimeFormatFunction(
                                                            invoiceDetails?.date_added,
                                                        )}
                                                    </td>
                                                    <td>
                                                        <>
                                                            Online
                                                            {/* {data.mk_card_number} (
                                                                    {data.card_type}) */}
                                                            {/* {capitalize(
                                                                    data.payment_method,
                                                                    // t,
                                                                )} */}
                                                        </>
                                                    </td>
                                                    <td>
                                                        {currencyFormat(invoiceDetails?.amount)}
                                                    </td>
                                                    <td
                                                        style={{
                                                            color: 'green',
                                                        }}
                                                    >
                                                        {'Success'}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </>
                                </div>
                            </>
                        ) : null}

                        <h4 className="invoiceSubTitle mt-5">{'Membership details'}</h4>

                        <div className="table-responsive">
                            {invoiceDetails ? (
                                <div className="cartProducts">
                                    <div className=" d-flex justify-content-between align-items-start">
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span className="highlet">
                                                    {'Membership Plan'} :
                                                </span>
                                                <span>TimeBidder</span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className=" d-flex justify-content-between align-items-start">
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span className="highlet">
                                                    {'Membership Period'}:
                                                </span>
                                                <span>
                                                    {capitalize(invoiceDetails?.membership_period)}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className=" d-flex justify-content-between align-items-start">
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span className="highlet">
                                                    {'Membership Start Date'}:
                                                </span>
                                                <span>
                                                    {dateTimeFormatFunction(
                                                        invoiceDetails?.membership_date,
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className=" d-flex justify-content-between align-items-start">
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span className="highlet">
                                                    {'Membership End Date'}:
                                                </span>
                                                <span>
                                                    {dateTimeFormatFunction(
                                                        invoiceDetails?.membership_enddate,
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>

                        <div className="row mt-4">
                            <div className="col-12">
                                <div className="table-responsive">
                                    <table className="table table-clear nellisInvTot">
                                        <tbody>
                                            <tr>
                                                <td className="left" align="right">
                                                    <span className="text-dark">{'Subtotal'}</span>
                                                </td>
                                                <td className="right">
                                                    <span className="text-dark">
                                                        {currencyFormat(invoiceDetails?.amount)}
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="left" align="right">
                                                    <span className="text-dark">
                                                        {'Total amount'}
                                                    </span>
                                                </td>
                                                <td className="right">
                                                    <span className="text-dark">
                                                        {currencyFormat(invoiceDetails?.amount)}
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="left" align="right">
                                                    <span className="text-dark">
                                                        {'Total paid'}
                                                    </span>
                                                </td>
                                                <td className="right">
                                                    <span className="text-dark">
                                                        {currencyFormat(invoiceDetails?.amount)}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {/* <div className="sttcContent">
                            {currentLanguage === 'for_arabic' ? (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: viewStatic.content_arabic,
                                    }}
                                ></div>
                            ) : (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: viewStatic.content,
                                    }}
                                ></div>
                            )}
                        </div> */}
                    </div>
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default InvoiceView
